/**
 * Command palette keyboard shortcuts and scopes.
 * These are team-agnostic shortcuts for the command palette component.
 */

import type { KeyboardShortcut } from "./keyboard-shortcut";

/**
 * Command palette scopes.
 */
export const commandPaletteScopes = ["commandPalette"] as const;

export type CommandPaletteScope = (typeof commandPaletteScopes)[number];

/** Command palette specific keyboard shortcut with scope */
export type CommandPaletteShortcut = KeyboardShortcut<CommandPaletteScope>;

/**
 * Command palette keyboard shortcuts.
 * These are the core navigation and action shortcuts.
 */
export const commandPaletteShortcuts = {
  TOGGLE: {
    code: "KeyK",
    keyLabel: "K",
    modifiers: ["meta"],
    scope: "commandPalette",
  },
  CLOSE: { code: "Escape", keyLabel: "Esc", scope: "commandPalette" },
  NAVIGATE_DOWN: { code: "ArrowDown", keyLabel: "↓", scope: "commandPalette" },
  NAVIGATE_UP: { code: "ArrowUp", keyLabel: "↑", scope: "commandPalette" },
  OPEN: { code: "Enter", keyLabel: "Enter", scope: "commandPalette" },
  OPEN_NEW_TAB: {
    code: "Enter",
    keyLabel: "Enter",
    modifiers: ["meta"],
    scope: "commandPalette",
  },
  GO_BACK: { code: "Backspace", keyLabel: "←", scope: "commandPalette" },
} as const satisfies Record<string, CommandPaletteShortcut>;

export type CommandPaletteShortcutId = keyof typeof commandPaletteShortcuts;
